import { Room } from "@domain";
import { UniqueEntityId } from "@kernel/ddd";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface UnPinParticipantInteractorProps {
  room: Room;
  participantId: UniqueEntityId;
}

export class UnPinParticipantInteractor extends SyncInteractor<
  UnPinParticipantInteractorProps,
  Room
> {
  public execute({ room, participantId }: UnPinParticipantInteractorProps): Room {
    const participants = room.getThumbnailParticipants();
    const participant = participants.getById(participantId);
    if (!participant) return room;
    participant.unpin();
    this.pinLocalParticipant(room);
    return Room.createFromRoom(room);
  }

  private pinLocalParticipant(room: Room): void {
    const localParticipant = room.localParticipant
    if (localParticipant) localParticipant.pin();
  }

  public static create(): UnPinParticipantInteractor {
    return new UnPinParticipantInteractor();
  }
}
